module.exports = __webpack_public_path__ + "static/img/son3.6fd1d4de.png";